import React from 'react'
import { Gradientbutton } from './GradientButton.style'

interface GradientButtonProps {
	disabled?: boolean;
	text: string;
	onClick?: () => any,
	big?: boolean,
}

const GradientButton = (props: GradientButtonProps) => {
	return (
		<Gradientbutton
			className="gradient"
			onClick={props.onClick}
			big={props.big}
			disabled={props.disabled}
		>
			{props.text}
		</Gradientbutton>
	)
}

export default GradientButton
